module.exports = __webpack_public_path__ + "img/animated_bot2.d961691a.gif";